"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserContext = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
exports.UserContext = react_1.createContext({
    user: undefined,
    hasPermission: lodash_1.stubFalse,
    isLogedIn: lodash_1.stubFalse,
    reload: noopPromise,
    logout: lodash_1.noop,
    logoutWithoutRedirect: lodash_1.noop,
});
async function noopPromise() { }
//# sourceMappingURL=user-context.js.map